import Vue from 'vue';
const $t = Vue.i18n.translate;

export default () => [
    { value: null, text: $t('data.languages.(Seleccionar)', '(Seleccionar)'), disabled: true },
    { value: 'espanol', text: $t('data.languages.Español', 'Spanish') },
    { value: 'catalan', text: $t('data.languages.Catalán', 'Catalan') },
    { value: 'ingles', text: $t('data.languages.Inglés', 'English') },
    { value: 'frances', text: $t('data.languages.Francés', 'French') },
];
